import Layout from '../../internal/Layout.vue'
import EquipmentPage from './index.vue'

const EquipmentRoutes = {
  component: Layout,
  children: [
    {
      name: 'equipment-central',
      path: '/',
      component: EquipmentPage,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
  ],
}

export default EquipmentRoutes
